module.exports = __webpack_public_path__ + "img/logo-grupo-verfrut-gh.606330c5.png";